import React, { useState, useEffect } from 'react';

// Services
import { subscriptionStatuses } from 'services/constants';

// Components
import SelectMultiple from 'components/select-multiple';

// ---------------------------------------------------------------------------------------------- \\
// --------------------------------- SELECT SUBSCRIPTION STATUS --------------------------------- \\
// ---------------------------------------------------------------------------------------------- \\

const SelectSubscriptionStatuses = ({ statuses, setStatuses }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        setOptions(subscriptionStatuses.map(s => ({ label: s.label, value: s.value })));
    }, []);

    return (
        <SelectMultiple
            value={statuses}
            onChange={value => setStatuses(value)}
            options={options}
            placeholder="Statut"
        />
    );
};

export default SelectSubscriptionStatuses;
